<template>
    <user-form/>
</template>

<script>
    import UserForm from '../../components/UserForm'

    export default {
        components: {
            UserForm
        }
    }
</script>
